import React, { Component } from "react"

const angleDiff = (destinationAngle, sourceAngle) => {
  const distance = destinationAngle - sourceAngle

  if (distance < -180) return distance + 360

  if (distance > 179) return distance - 360

  return distance
}

export class Motion extends Component {
  constructor(props) {
    super(props)

    this.onChangeOrientation = props.onChangeOrientation
  }

  handleOrientation(event) {
    if (this.offsetBeta === undefined) {
      console.log(
        "und",
        this.offsetBeta,
        event.beta,
        this.offsetGamma,
        event.gamma
      )
      this.offsetBeta = event.beta
      this.offsetGamma = event.gamma
    } else {
      console.log("set", this.offsetBeta, this.offsetGamma)
      this.onChangeOrientation({
        beta: angleDiff(event.beta, this.offsetBeta),
        gamma: angleDiff(event.gamma, this.offsetGamma),
      })

      this.offsetBeta = 0.99 * this.offsetBeta + 0.01 * event.beta
      this.offsetGamma = 0.99 * this.offsetGamma + 0.01 * event.gamma
    }
  }

  checkDeviceEvents() {
    const self = this
    if (typeof DeviceOrientationEvent.requestPermission === "function") {
      DeviceOrientationEvent.requestPermission()
        .then(permissionState => {
          if (permissionState === "granted") {
            window.addEventListener(
              "deviceorientation",
              self.handleOrientation.bind(this),
              true
            )
          }
        })
        .catch(console.error)
    } else {
      //window.addEventListener("deviceorientation", handleOrientation, true)
    }
  }

  render() {
    return (
      <div style={{ position: "absolute", zIndex: 1000 }}>
        <button type="button" onClick={this.checkDeviceEvents.bind(this)}>
          track
        </button>
      </div>
    )
  }
}
